const ParameterFormatter = ({value}) => (
    value === undefined || value === null || value === '' ? '-' : value
);

export default ParameterFormatter;
